<section id="destinations" class="w-full pb-15">
    <!-- Header -->
<app-banner_section-type01
  [options]="{ title: '', imageHref: this.view.imageHref }">
</app-banner_section-type01>
    <!-- <div class="flex relative flex-col justify-center items-center h-[450px] bg-cover bg-no-repeat bg-center"
        [style.background-image]="'url(' +view.packageImageUrl + ')'">
        <img class="w-full" [src]="view.destination.imageUrlBg" alt="">
        <div class="absolute inset-0 bg-gradient-to-t from-gray-800 via-gray-800/40"></div>
        <h1 class="z-10 custom_font text-7xl text-primary text-shadow uppercase">Packages</h1>
        <span
            class="z-10 custom_font text-xl md:text-3xl text-white text-center text-shadow xl-heading">{{view.destination.tagline}}</span>
    </div> -->
    <h1 class="text-center pt-10 font-bold text-2xl">Popular Destinations</h1>
    <div class="px-10 pt-6 m-auto items-center text-center ">
        <div 
            class="inline-flex items-center text-center p-2 cursor-pointer rounded-lg hover:bg-gray-200 mx-2" 
            *ngFor="let region of regions" 
            (click)="onRegionSelect(region)"
            [class.bg-primary-500]="view.selectedRegion === region" 
            [class.text-white]="view.selectedRegion === region"
        >
            <span class="mx-2">{{ region }}</span>
        </div>
    </div>

    <!-- Package Short info and Meta Tags -->
  
    <!-- <div class="pt-16 px-4">
        <form class="flex items-center max-w-sm mx-auto">   
            <label for="simple-search" class="sr-only">Search</label>
            <div class="relative w-full">
                <input type="text"  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-accent-500 block w-full ps-10 p-2.5  " placeholder="Search Destination" (input)="onSearchQueryChange($event)"/>
            </div>
        </form>
    </div> -->

    <!-- Packages Information Cards -->
    @if (view.filteredBundles && view.filteredBundles.length > 0) {
        <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-8 px-4 md:px-8 lg:px-15 mt-15">
                @for(bundle of view.filteredBundles; track bundle) {
                    @if (bundle.nights > 0) {
                        <fuse-card class="flex flex-col w-full w-[350px] mx-auto overflow-hidden shadow-lg hover:shadow-xl relative">
                            <!-- Ribbon Section -->
                            <div class="absolute left-0 top-0 h-26 w-26 z-20">
                                <div
                                    class="absolute transform -rotate-45 bg-accent-600 text-center text-white font-semibold py-1 right-[-55px] top-[52px] w-[240px] z-20 ">
                                    Black Friday 
                                </div>
                            </div>

                            <!-- Rest of the Card Content -->
                            <div class="relative">
                                <img class="w-full z-10 h-60" [src]="bundle.imageUrls[0]" alt="Package Image" alt="Package Image">
                                <div class="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-900/40"></div>
                                <div class="absolute top-0 right-0 text-white px-8 py-5 text-xl tracking-wider custom_font">
                                   {{bundle.supplier ? bundle.destinationName : bundle.destination}}
                                </div>
                                <!-- Icons section -->
                                <div class="flex absolute top-0 right-0 justify-center items-center px-8 py-15">
                                @if(bundle.priceAccommodation) {
                                <div class="mr-3 text-white tracking-wider" [matTooltip]="'Accommodation'">
                                    <mat-icon
                                        class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                                        [svgIcon]="'heroicons_outline:home-modern'"></mat-icon>
                                </div>
                                }
                                @if(bundle.priceFlights && !bundle.excludeFlights) {
                                <div class="mr-3 text-white tracking-wider" [matTooltip]="'Flights'">
                                    <mat-icon
                                        class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                                        [svgIcon]="'mat_outline:airplanemode_active'"></mat-icon>
                                </div>
                                }
                                @if(bundle.priceCars) {
                                <div class="mr-3 text-white tracking-wider" [matTooltip]="'Car Rental'">
                                    <mat-icon
                                        class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                                        [svgIcon]="'mat_outline:directions_car'"></mat-icon>
                                </div>
                                }
                                @if(bundle.priceTransfers) {
                                <div class="mr-3 text-white tracking-wider" [matTooltip]="'Transfers'">
                                    <mat-icon
                                        class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                                        [svgIcon]="'mat_outline:airport_shuttle'"></mat-icon>
                                </div>
                                }
                                @if(bundle.priceCruises) {
                                <div class="mr-3 text-white tracking-wider" [matTooltip]="'Cruise'">
                                    <mat-icon
                                        class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                                        [svgIcon]="'mat_outline:directions_boat'"></mat-icon>
                                </div>
                                }
                            </div>
                            </div>

                            <!-- Card Body -->
                            <div class="flex flex-col justify-center bg-white dark:bg-slate-800 p-4">
                                <div class="flex flex-col justify-center bg-white dark:bg-slate-800 p-4">
                                    <div class="flex mb-2 h-4">
                                        @if(bundle.supplier && bundle.supplier.grading > 0 && bundle.supplier.grading <= 1) { 
                                            <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        }
                                        @if(bundle.supplier && bundle.supplier.grading > 1 && bundle.supplier.grading <= 2) {
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        }
                                        @if(bundle.supplier && bundle.supplier.grading > 2 && bundle.supplier.grading <= 3) { 
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        }
                                        @if(bundle.supplier && bundle.supplier.grading > 3 && bundle.supplier.grading <= 4) {
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        }
                                        @if(bundle.supplier && bundle.supplier.grading > 4 && bundle.supplier.grading <= 5) {
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        }
                                    </div>
                                    <p class="text-2xl custom_font font-semibold mb-2 h-14">
                                       {{bundle.supplier ? bundle.supplier.name : bundle.name}}
                                    </p>
                                    <div class="flex items-center justify-between">
                                        <div class="flex flex-col space-y-2">
                                            <p class="text-gray-500">{{bundle.search.nights}} {{bundle.search.nights === 1 ? 'Night' : 'Nights'}}</p>
                                            <p class="text-gray-500">From
                                                <span class="text-primary-500 text-2xl font-semibold ml-2">{{bundle.priceBundleTotal |
                                            currency:bundle.currency:'symbol-narrow'}}</span>
                                                <sup class="text-gray-500 ml-1">pps</sup>
                                            </p>
                                        </div>
                                        <a  [routerLink]="['/package', bundle.id, bundle.slug ? bundle.slug : slugify(bundle.name)]"  type="button"
                                            class="ring-2 ring-accent-500 rounded-lg font-bold py-2 px-6 transition transition-duration-500 hover:bg-accent-500 hover:text-primary-100">
                                            View More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </fuse-card>
                    }
                }
        </div>
    }
        <!-- <div class="text-center text-gray-500 mt-8 ">
            <p class="text-center">No results found</p>
        </div> -->
                <!-- <app-destination-list-type01></app-destination-list-type01> -->
</section>